import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectCommunities } from '@/store/user/selectors/selectCommunities';
import { joinCommunityThunk } from '@/store/user/thunks/joinCommunityThunk';
import { leaveCommunityThunk } from '@/store/user/thunks/leaveCommunityThunk';
import JoinCommunityIcon from '@/styles/Icons/JoinCommunityIcon';
import LeaveCommunityIcon from '@/styles/Icons/LeaveCommunityIcon';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const StyledCommunityButton = styled.div`
  .icon {
    display: block;
  }

  margin-bottom: 10px;

  .icon-leave-community,
  .icon-join-community {
    fill: ${p => p.colors.text};
    width: 41px;
    height: 40px;

    @media (max-width: 480px) {
      width: 34px;
      height: 33px;
    }

    cursor: pointer;

    .filling-area {
      transition: all 0.4s;
      fill: ${p => p.colors.fillColor};
    }

    &:hover .main-outline {
      fill: ${props => props.colors.fillColor};
    }
  }
`;

export function CommunitySideButtons({ community, colors }) {
  const { activeProfileId } = useActiveProfile();
  const [token] = useTokenState();
  const dispatch = useDispatch();
  const memberOfCommunities = useSelector(state =>
    selectCommunities(state, { activeProfileId })
  );

  if (
    !community.isCommunity ||
    activeProfileId === community.id ||
    memberOfCommunities === undefined
  ) {
    return null;
  }

  const isInCommunity = Boolean(memberOfCommunities[community.id]);

  const leaveCommunity = () => {
    if (window.confirm('Вы уверены, что хотите выйти из сообщества?')) {
      dispatch(
        leaveCommunityThunk({
          activeProfileId,
          communityId: community.id,
          token
        })
      );
    }
  };
  const joinCommunity = () => {
    dispatch(
      joinCommunityThunk({
        activeProfileId,
        community,
        token
      })
    );
  };

  return (
    <div>
      <StyledCommunityButton
        colors={colors}
        onClick={isInCommunity ? leaveCommunity : joinCommunity}
        title={isInCommunity ? 'выйти из сообщества' : 'вступить в сообщество'}
      >
        {isInCommunity ? <LeaveCommunityIcon /> : <JoinCommunityIcon />}
      </StyledCommunityButton>
    </div>
  );
}
